import { WppButton } from '@platform-ui-kit/components-library-react'
import { useTranslation } from 'react-i18next'

import { newIntercomMessage } from 'components/intercom/utils'
import { handleOpenWidget } from 'components/zendesk'
import { WIDGET_PAGE_CODES } from 'components/zendesk/utils/constants'
import { useOsSupportService } from 'providers/osSupportService/OsSupportServiceContext'

export const SupportButton = () => {
  const { t } = useTranslation()
  const { intercom, zendesk } = useOsSupportService()

  if (!intercom.active && !zendesk.active) {
    return null
  }

  return (
    <WppButton
      data-testid="support-button"
      onClick={() => {
        if (intercom.active) {
          newIntercomMessage()
        }
        if (zendesk.active) {
          handleOpenWidget({ appOrPageCode: WIDGET_PAGE_CODES.OS_INTERNAL_PAGE })
        }
      }}
    >
      {t('os.help.get_support')}
    </WppButton>
  )
}
